/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Change } from '../model/change.model';
import { ChangeOptions, ObservableCollectionOptions } from './observable-collection.util';
import { ObservableMap } from './observable-map.util';

export interface ObservableModelData {
  [key: string]: any;
}

export class ObservableModel extends ObservableMap<any> implements ObservableModelData {
  private readonly allowedKeys: Set<string>;

  constructor(values?: ObservableModelData, allowedKeys?: string[], observeOptions?: ObservableCollectionOptions) {
    super(null, observeOptions);
    this.allowedKeys = allowedKeys ? new Set(allowedKeys) : null;
    this.setValues(values, { exclusive: true, force: true, silent: true });
  }

  set(key: string, value?: any, options?: ChangeOptions) {
    this.setValues({ [key]: value }, options);
  }

  setValues(values: ObservableModelData, options?: ChangeOptions): { [key: string]: Change<any> } {
    const exclusive = options && options.exclusive || false;
    return super.setValues(this.setupValues(Object.assign({}, values), exclusive), options);
  }

  protected setupValues(values: ObservableModelData, exclusive: boolean): ObservableModelData {
    if (this.allowedKeys) {
      Object.keys(values).forEach((key) => {
        if (!this.allowedKeys.has(key)) {
          delete values[key];
        }
      });
    }
    return values;
  }

  protected getSetupValue(values: ObservableModelData, key: string, exclusive: boolean) {
    if (key in values) {
      return values[key];
    }
    return exclusive ? undefined : this[key];
  }

  protected setupDefaultValue(data: ObservableModelData, key: string, defaultValue: any) {
    if (!(key in data)) {
      data[key] = defaultValue;
    }
  }

}
